<template>
    <div>
        <div class="columns is-mobile is-multiline">
            <div class="column is-full-mobile is-full-tablet is-full-desktop is-half-widescreen is-top-layer puppy-text">
                <div class="colored-background">
                    <h1 class="is-size-2 is-page-title">Puppy's</h1>
                    <p>
                        Het fokprogramma van het ras is een centrale taak van de vzw.
                        Daarom hechten wij groot belang aan nieuwe nestjes zodat we het ras verder kunnen uitbouwen
                        en ook zodat we mensen kunnen verblijden met een pup. Een tweede essentiële taak die hierbij
                        komt kijken is het informeren van toekomstige eigenaars opdat zij volledig voorbereid zouden
                        zijn op de komst van hun viervoeter.
                    </p>
                    <router-link to="/puppy" class="is-news-read-more">Lees meer</router-link>
                </div>
            </div>
            <div class="column is-full-tablet is-full-desktop is-half-widescreen puppy-picture">
                <figure class="image is-3by2">
                    <img :src="source" :key="source">
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Puppy",
        data: function() {
            return {
                source: ""
            }
        },
        mounted: function() {
            axios.get(process.env.VUE_APP_IMAGES_URL + '/pup/index.json').then(indexJson => {
              let images = [];
              indexJson.data.forEach(imageJson => {
                images.push(process.env.VUE_APP_IMAGES_URL + imageJson.location);            
              });
              let pupImagesCount = images.length;
              let imageNumber = Math.floor((Math.random() * pupImagesCount));
              this.source = images[imageNumber];
            });
        }
    }
</script>

<style scoped>
    p {
        margin-bottom: 16px;
    }
    .colored-background {
        background: #f5f5ef;
        padding: 10%;
        padding-top: 5%;
        margin-top: 3vh;
    }
    .is-top-layer {
        z-index: 2;
    }
    .column.puppy-picture {
        position: relative;
        top: 7.5vh;
        left: -5%;
        z-index: 1;
        margin-bottom: 15vh;
    }
    .puppy-picture img {
        object-fit: cover;
    }
    
    @media screen and (max-width: 1215px) {
        .column.puppy-picture {
            left: 0;
            top: 0;
            margin-bottom: 3vh;
            padding-top: 0;
        }
        .column.puppy-text {
            padding-bottom: 0;
        }
    }
    
    @media screen and (max-width: 768px) {
        .column.puppy-picture {
            position: relative;
            top: 0;
            left: 0;
            z-index: 1;
            margin-bottom: 5vh;
            padding-top: 0;
        }
        .column.puppy-text {
            padding-bottom: 0;
        }
    }
    
</style>